import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { organizationsOrganizationsRetrieveOptions } from 'src/api/main'

import { WorkspacePageShell, useWorkspaceRoute } from '../WorkspacePageShell'

import { CompanyGraphView } from './CompanyGraphView'

export const WorkspaceCompanyGraphPage = () => {
  const { t } = useTranslation()
  const { workspaceId, idValid } = useWorkspaceRoute()

  // Cached by react-query — the shell already fetched this org, so no extra
  // request; we read it here only to seed the company core node.
  const { data: organization } = useQuery({
    ...organizationsOrganizationsRetrieveOptions({
      path: { id: workspaceId }
    }),
    enabled: idValid
  })

  return (
    <WorkspacePageShell
      sectionTitle={t('workspaceOverview.companyGraph.title')}
      sectionDescription={t('workspaceOverview.companyGraph.pageDescription')}
    >
      <CompanyGraphView workspaceId={workspaceId} organization={organization} />
    </WorkspacePageShell>
  )
}
